import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Tisztelt Ügyfelünk! ")
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Adatkezelési tájékoztatónk 2026. február 2-án módosult. ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" A változás alapján az RTL+ lekérhető médiaszolgáltatással összefüggésben a profilalkotáshoz kapcsolódó adatkezelések időtartama egységesen 2 év valamennyi profilalkotási tevékenység esetén és új adatkezelések kerültek bevezetésre a Google Ads, valamint a Google Analytics 4 használatához kapcsolódóan, valamint az RTL+ szolgáltatással kapcsolatos visszajelző űrlappal összefüggésben. A tájékoztatóból kivezetésre került az RTL.hu felülettel kapcsolatos hírlevélküldési tevékenység, pontosítás történt az RTL+ Active szolgáltatáshoz kapcsolódó adatkezeléssel összefüggésben és frissítettük az adatfeldolgozóink listáját is. ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" A módosított adatkezelési tájékoztató teljes szövege elérhető ezen a ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://rtl.hu/adatvedelmi-szabalyzat",
  target: "_blank"
}, " linken", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Üdvözlettel: ")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" M-RTL Zrt. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_main_layout = _resolveComponent("main-layout")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_main_layout, null, {
      default: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 1
    }),
    (_ctx.showPrivacyModal)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 0,
          class: "privacy-modal",
          onClose: _ctx.closePrivacyModal
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _hoisted_2,
            _hoisted_3,
            _hoisted_4,
            _hoisted_5,
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _hoisted_10,
            _hoisted_11,
            _hoisted_12,
            _hoisted_13,
            _hoisted_14,
            _hoisted_15,
            _hoisted_16
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}